import React from 'react';
import ReactDOM from 'react-dom';

import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';

import { tipos, status } from '../../util/empreendimentos';
import ModalRegras from './ModalRegras';

import './Style.css';

class ConfigurarPesosAvaliacao extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            pesos: [],
            busca: '',
            form: this.getFormInicial(),
            modalRegrasOpen: false,
            editandoId: null,
            errors: {},
            loading: false,
            loadingLista: false,
            salvando: false,
            excluindoId: null,
        };

        this.tipos = [
            {
                value: "Avaliação",
                label: "Avaliação",
            },
            {
                value: "Demérito",
                label: "Demérito",
            },
            {
                value: "Auditoria",
                label: "Auditoria",
            },
        ];

        this.buildingTypesList = Array.isArray(tipos) ? tipos : [];
        this.buildingStatusList = Array.isArray(status) ? status : [];
    }

    componentDidMount() {
        this.buscarPesos();
    }

    /**
     * Estado inicial do formulário.
     */
    getFormInicial = () => {
        return {
            type: "",
            reason: "",
            criterion: "",
            building_type: [],
            building_status: [],
            weigth: "",
            rules: {},
        };
    };

    /**
     * =========================================================
     * NORMALIZAÇÃO
     * =========================================================
     *
     * Garante que os dados recebidos do Laravel tenham sempre o formato esperado pelo React.
     */
    normalizarLista = (lista) => {
        if (!Array.isArray(lista)) {
            return [];
        }

        return lista.map((item) => ({
            ...item,
            building_type: this.normalizarMultiValor(item.building_type),
            building_status: this.normalizarMultiValor(item.building_status),
            rules: item.rules && typeof item.rules === 'object' ? item.rules : {},
        }));
    };

    normalizarMultiValor = (valor) => {
        if (Array.isArray(valor)) {
            return valor;
        }

        if (typeof valor === 'string') {
            if (!valor.trim()) {
                return [];
            }

            return valor
                .split(',')
                .map((item) => item.trim())
                .filter(Boolean);
        }

        return [];
    };

    /**
     * =========================================================
     * GET
     * =========================================================
     *
     * O loading é ativado ANTES da requisição.
     *
     * Só é desligado depois que os dados foram:
     *
     * 1. recebidos;
     * 2. normalizados;
     * 3. filtrados/processados;
     * 4. colocados no state.
     */
    buscarPesos = async () => {
        const { busca } = this.state;

        this.setState({
            loading: true,
            loadingLista: true,
            errors: {},
        });

        try {
            const response = await axios.get(
                '/listar-pesos',
                {
                    params: {
                        busca: busca.trim(),
                    },
                }
            );
            const payload = response?.data?.data ?? [];

            let pesosProcessados = this.normalizarLista(payload);

            this.setState({
                pesos: pesosProcessados,
                loading: false,
                loadingLista: false,
            });
        } catch (error) {
            console.error('Erro ao buscar pesos:', error);

            this.setState({
                pesos: [],
                loading: false,
                loadingLista: false,
                errors: error?.response?.data?.errors || {},
            });
        }
    };

    handleBuscaChange = (event) => {
        this.setState({
            busca: event.target.value,
        });
    };

    handleBuscar = (event) => {
        event.preventDefault();

        if (this.state.loading || this.state.salvando) {
            return;
        }

        this.buscarPesos();
    };

    handleLimparBusca = () => {
        if (this.state.loading || this.state.salvando) {
            return;
        }

        this.setState(
            {
                busca: '',
            },
            () => {
                this.buscarPesos();
            }
        );
    };

    /**
     * =========================================================
     * CAMPOS DO FORMULÁRIO
     * =========================================================
     */
    handleInputChange = (event) => {
        const {
            name,
            value,
        } = event.target;

        this.setState((prevState) => ({
            form: {
                ...prevState.form,
                [name]: value,
            },
            errors: {
                ...prevState.errors,
                [name]: undefined,
            },
        }));
    };

    handleTipoChange = (event) => {
        this.setState((prevState) => ({
            form: {
                ...prevState.form,
                type: event.value ?? '',
            },
        }));
    };

    handleTipoEmpreendimentoChange = (event) => {
        this.setState((prevState) => ({
            form: {
                ...prevState.form,
                building_type: event.value || [],
            },
        }));
    };

    handleStatusChange = (event) => {
        this.setState((prevState) => ({
            form: {
                ...prevState.form,
                building_status: event.value || [],
            },
        }));
    };

    /**
     * =========================================================
     * REGRAS
     * =========================================================
     */
    handleRegraChange = (rules) => {
        this.setState((prevState) => ({
            form: {
                ...prevState.form,
                rules: rules && typeof rules === 'object' ? rules : {},
            },
        }));
    };

    showModalRegra = () => {
        if ( this.state.loading || this.state.salvando ) {
            return;
        }

        this.setState({
            modalRegrasOpen: true,
        });
    };

    closeModalRegra = () => {
        this.setState({
            modalRegrasOpen: false,
        });
    };

    possuiRegra = () => {
        const rules = this.state.form.rules;

        if (!rules) {
            return false;
        }

        return (
            typeof rules === 'object' && Object.keys(rules).length > 0
        );
    };

    /**
     * =========================================================
     * VALIDAÇÃO
     * =========================================================
     */

    validarFormulario = () => {
        const {
            form,
        } = this.state;

        if (!form.type) {
            alert('Selecione o tipo.');
            return false;
        }

        if (!String(form.reason ?? '').trim()) {
            alert('Informe o motivo.');
            return false;
        }

        if (!String(form.criterion ?? '').trim()) {
            alert('Informe o critério.');
            return false;
        }

        if (!Array.isArray(form.building_type) || form.building_type.length === 0) {
            alert('Selecione pelo menos um tipo de empreendimento.');
            return false;
        }

        if (!Array.isArray(form.building_status) || form.building_status.length === 0) {
            alert('Selecione pelo menos um status.');
            return false;
        }

        if (
            form.weigth === '' ||
            form.weigth === null ||
            form.weigth === undefined
        ) {
            alert('Informe o peso.');
            return false;
        }

        const weigth = Number(form.weigth);

        if (Number.isNaN(weigth) || !Number.isFinite(weigth)) {
            alert('Informe um peso válido.');
            return false;
        }

        if (weigth <= 0) {
            alert('O peso deve ser maior que zero.');
            return false;
        }

        return true;
    };

    /**
     * =========================================================
     * PAYLOAD
     * =========================================================
     *
     * Cria uma cópia limpa dos dados que realmente devem ser enviados para o Laravel.
     */
    montarPayload = () => {
        const {
            form,
        } = this.state;

        const weigth = Number(form.weigth);

        return {
            type: form.type,
            reason: String(form.reason ?? '').trim(),
            criterion: String(form.criterion ?? '').trim(),
            building_type: Array.isArray(form.building_type) ? [...form.building_type] : [],
            building_status: Array.isArray(form.building_status) ? [...form.building_status] : [],
            weigth,
            rules: form.rules && typeof form.rules === 'object' ? form.rules : {},
        };
    };

    /**
     * =========================================================
     * SUBMIT
     * =========================================================
     */
    handleSubmit = async (event) => {
        event.preventDefault();

        /*
         * Impede duplo clique / múltiplas requisições.
         */
        if (this.state.salvando || this.state.loading) {
            return;
        }

        if (!this.validarFormulario()) {
            return;
        }

        const {
            editandoId,
        } = this.state;

        const peso = this.montarPayload();

        this.setState({
            salvando: true,
            loading: true,
            errors: {},
        });

        try {
            if (editandoId !== null) {
                /*
                 * =================================================
                 * ATUALIZAÇÃO
                 * =================================================
                 */
                await axios.put(`/atualizar-peso/${editandoId}`, peso);
            } else {
                /*
                 * =================================================
                 * NOVO CADASTRO
                 * =================================================
                 */
                await axios.post('/salvar-pesos', peso);
            }

            await this.buscarPesos();

            this.setState({
                form: this.getFormInicial(),
                editandoId: null,
                modalRegrasOpen: false,
                errors: {},
            });

            alert('Peso configurado com sucesso');
        } catch (error) {
            console.error('Erro ao salvar peso:', error);

            const status = error?.response?.status;

            if (status === 400 || status === 422) {
                this.setState({
                    errors: error?.response?.data?.errors || {},
                });

                alert('Verifique os dados informados.');
            } else {
                alert('Não foi possível salvar o peso. Tente novamente mais tarde.');
            }
        } finally {
            this.setState({
                salvando: false,
                loading: false,
            });
        }
    };

    /**
     * =========================================================
     * EDITAR
     * =========================================================
     */
    handleEditar = (peso) => {
        if (this.state.loading || this.state.salvando) {
            return;
        }

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        this.setState({
            editandoId: peso.id,

            form: {
                type: peso.type ?? '',
                reason: peso.reason ?? '',
                criterion: peso.criterion ?? '',
                building_type: this.normalizarMultiValor(peso.building_type),
                building_status: this.normalizarMultiValor(peso.building_status),
                weigth: peso.weigth ?? '',
                rules: peso.rules && typeof peso.rules === 'object' ? peso.rules : {},
            },

            errors: {},
        });
    };

    /**
     * =========================================================
     * EXCLUIR
     * =========================================================
     */
    handleExcluir = async (id) => {
        if (
            this.state.loading ||
            this.state.salvando ||
            this.state.excluindoId !== null
        ) {
            return;
        }

        const confirmar = window.confirm('Deseja realmente excluir este peso?');
        if (!confirmar) {
            return;
        }

        this.setState({
            excluindoId: id,
            loading: true,
        });

        try {
            await axios.delete(`/deletar-peso/${id}`);

            await this.buscarPesos();

            if (this.state.editandoId === id) {
                this.setState({
                    form: this.getFormInicial(),
                    editandoId: null,
                });
            }

            alert('Peso excluído com sucesso.');
        } catch (error) {
            console.error('Erro ao excluir peso:', error);
            alert('Erro ao excluir peso.');
        } finally {
            this.setState({
                excluindoId: null,
                loading: false,
            });
        }
    };

    /**
     * =========================================================
     * CANCELAR EDIÇÃO
     * =========================================================
     */
    handleCancelarEdicao = () => {
        if (this.state.salvando || this.state.loading) {
            return;
        }

        this.setState({
            form: this.getFormInicial(),
            editandoId: null,
            errors: {},
        });
    };

    /**
     * =========================================================
     * EXIBIÇÃO DOS MULTISELECTS
     * =========================================================
     */
    renderValores = (valores) => {
        if (!Array.isArray(valores) || valores.length === 0) {
            return '-';
        }

        if (valores.length === this.buildingTypesList.length) {
            return 'Todos';
        }

        return valores.join(', ');
    };

    render() {
        const {
            pesos,
            form,
            modalRegrasOpen,
            editandoId,
            loading,
            loadingLista,
            salvando,
            excluindoId,
        } = this.state;

        const regraAtiva = this.possuiRegra();

        return (
            <div>
                <div className="row pesos">
                    <div className="col-12 col-sm-4 col-md-6 col-lg-8">
                        <div className="card" style={{ height: '100%' }}>
                            <p className="title">Lista de pesos</p>

                            <form
                                className="form-pesquisa-pesos"
                                onSubmit={this.handleBuscar}
                            >
                                <div className="form-group">
                                    <div style={{ display: 'flex', gap: '5px' }}>
                                        <input
                                            type="text"
                                            value={this.state.busca}
                                            onChange={this.handleBuscaChange}
                                            placeholder="Buscar motivo ou critério"
                                            className="form-control campo"
                                            disabled={loading || salvando}
                                        />

                                        <button
                                            type="submit"
                                            className="btn btn-submit-form"
                                            disabled={loading || salvando}
                                        >
                                            <i className="fa fa-search"></i>
                                        </button>

                                        {this.state.busca && (
                                            <button
                                                type="button"
                                                className="btn btn-editar"
                                                onClick={this.handleLimparBusca}
                                                disabled={loading || salvando}
                                                title="Limpar busca"
                                            >
                                                <i className="fa fa-times"></i>
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </form>

                            {loadingLista ? (
                                <div className="cliente-form">
                                    <div className="ef-loading">
                                        <i className="fa fa-spinner fa-spin"></i>{' '}
                                        Carregando...
                                    </div>
                                </div>
                            ) : (
                                pesos.length === 0 ? (
                                    <p className="title">Nenhum peso cadastrado.</p>
                                ) : (
                                    <div className="table-responsive">
                                        <table className="tabela-pesos">
                                            <thead>
                                                <tr>
                                                    <th>Tipo</th>
                                                    <th>Motivo</th>
                                                    <th>Critério</th>
                                                    <th>Regra</th>
                                                    <th>Nota</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pesos.map(
                                                    (peso) => (
                                                        <tr key={ peso.id }>
                                                            <td>{ peso.type }</td>
                                                            <td>
                                                                <div className="limit">
                                                                    { peso.reason }
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="limit">
                                                                    { peso.criterion }
                                                                </div>
                                                            </td>
                                                            <td>
                                                                {
                                                                    peso.rules &&
                                                                    Object.keys( peso.rules || {} ).length > 0 &&
                                                                    peso.rules.no_rule === false ? 'Sim' : 'Não'
                                                                }
                                                            </td>
                                                            <td style={{ textAlign: 'center' }}>{peso.weigth}</td>
                                                            <td>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-editar"
                                                                    title="Editar"
                                                                    onClick={ () => this.handleEditar(peso) }
                                                                    disabled={ loading || salvando }
                                                                >
                                                                    <i className="fa fa-edit"></i>
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-excluir"
                                                                    title="Excluir"
                                                                    onClick={ () => this.handleExcluir(peso.id) }
                                                                    disabled={
                                                                        loading ||
                                                                        salvando ||
                                                                        excluindoId !== null
                                                                    }
                                                                    style={{ marginLeft: '5px' }}
                                                                >
                                                                    {excluindoId ===
                                                                    peso.id ? (
                                                                        <i className="fa fa-spinner fa-spin"></i>
                                                                    ) : (
                                                                        <i className="fa fa-trash"></i>
                                                                    )}
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )
                            )}
                        </div>
                    </div>

                    <div className="col-12 col-sm-4 col-md-6 col-lg-4">
                        <div className="card">
                            <p className="title">{editandoId !== null ? 'Editar peso' : 'Cadastrar peso'}</p>

                            <form className="form-pesos" onSubmit={ this.handleSubmit }>
                                <div className="form-group">
                                    <label>Tipo</label>
                                    <Dropdown
                                        value={ form.type }
                                        options={ this.tipos }
                                        onChange={ this.handleTipoChange }
                                        placeholder="Selecione"
                                        className="dropdown"
                                        showClear
                                        disabled={ salvando }
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Motivo</label>
                                    <input
                                        type="text"
                                        name="reason"
                                        value={ form.reason }
                                        onChange={ this.handleInputChange }
                                        placeholder="Digite"
                                        className="form-control campo"
                                        maxLength={255}
                                        disabled={ salvando }
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Critério</label>
                                    <input
                                        type="text"
                                        name="criterion"
                                        value={ form.criterion }
                                        onChange={ this.handleInputChange }
                                        placeholder="Digite"
                                        className="form-control campo"
                                        maxLength={255}
                                        disabled={ salvando }
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Tipo do Empreendimento</label>
                                    <MultiSelect
                                        value={ form.building_type }
                                        options={ this.buildingTypesList }
                                        onChange={ this.handleTipoEmpreendimentoChange }
                                        placeholder="Selecione"
                                        display="chip"
                                        showClear
                                        selectedItemsLabel="{0} itens selecionados"
                                        emptyFilterMessage="Nenhum resultado encontrado"
                                        className="dropdown"
                                        optionLabel="label"
                                        optionValue="value"
                                        filter
                                        filterBy="label"
                                        disabled={ salvando }
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Status</label>
                                    <MultiSelect
                                        value={ form.building_status }
                                        options={ this.buildingStatusList }
                                        onChange={ this.handleStatusChange }
                                        placeholder="Selecione"
                                        display="chip"
                                        showClear
                                        selectedItemsLabel="{0} itens selecionados"
                                        emptyFilterMessage="Nenhum resultado encontrado"
                                        className="dropdown"
                                        optionLabel="label"
                                        optionValue="value"
                                        filter
                                        filterBy="label"
                                        disabled={ salvando }
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Nota</label>
                                    <input
                                        type="number"
                                        name="weigth"
                                        value={ form.weigth }
                                        onChange={ this.handleInputChange }
                                        placeholder="Digite"
                                        className="form-control campo"
                                        min={1}
                                        step="any"
                                        disabled={ salvando }
                                    />
                                </div>

                                <div className="form-group">
                                    <button
                                        type="button"
                                        className={ regraAtiva ? 'btn btn-adicionar-regra active' : 'btn btn-adicionar-regra' }
                                        onClick={ this.showModalRegra }
                                        disabled={ salvando }
                                    >
                                        Regra +
                                    </button>
                                </div>

                                <div className="row">
                                    <div className="hidedn-xs hidden-sm col-md-6 col-lg-6">
                                        {editandoId !==
                                            null && (
                                            <button
                                                type="button"
                                                className="btn btn-block btn-edit-form"
                                                onClick={ this.handleCancelarEdicao }
                                                disabled={ salvando }
                                            >
                                                CANCELAR
                                            </button>
                                        )}
                                    </div>

                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <button
                                            type="submit"
                                            className="btn btn-block btn-submit-form"
                                            disabled={ salvando }
                                        >
                                            {salvando ? (
                                                <>
                                                    <i className="fa fa-spinner fa-spin"></i>{' '}
                                                    Salvando...
                                                </>
                                            ) : editandoId !==
                                              null ? (
                                                'ATUALIZAR'
                                            ) : (
                                                'SALVAR'
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>


                    <ModalRegras
                        show={ modalRegrasOpen }
                        closeModal={ this.closeModalRegra }

                        /*
                         * Regras do peso que está sendo criado/editado.
                         */
                        regras={ form.rules }

                        /*
                         * Regra específica atualmente configurada.
                         */
                        regraAtual={ form.rules && typeof form.rules === 'object' ? form.rules : null }
                        onRegraChange={ this.handleRegraChange }
                    />
                </div>
            </div>
        );
    }
}

if (document.getElementById('app-configurar-pesos-avaliacao')) {
    ReactDOM.render(<ConfigurarPesosAvaliacao />, document.getElementById('app-configurar-pesos-avaliacao'));
}
export default ConfigurarPesosAvaliacao;